import { AxiosResponse } from "axios";
import qs from "qs";
import { AxiosInstance } from "./axiosInstance";
import {
  EmailUpsertPayload,
  GetEmailListResponse,
  GetEmailRecipientListResponse,
  GetEmailRequest,
} from "./interfaces/emailInterface.interface";

const API_PATH = "/setting/email";

export const getEmailList = async ({
  payload,
  isSchedule,
  accountId,
}: {
  payload: GetEmailRequest;
  isSchedule?: boolean;
  accountId: string;
}): Promise<GetEmailListResponse> => {
  try {
    const res: AxiosResponse<GetEmailListResponse> = await AxiosInstance.get(
      `${API_PATH}/list/${accountId}?${qs.stringify(
        payload
      )}&isSchedule=${isSchedule}`
    );
    return res.data;
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};

export const getEmailRecipientList = async ({
  payload,
  emailId,
  accountId,
}: {
  payload: GetEmailRequest;
  emailId: string;
  accountId: string;
}): Promise<GetEmailRecipientListResponse> => {
  try {
    const res: AxiosResponse<GetEmailRecipientListResponse> =
      await AxiosInstance.get(
        `${API_PATH}/list/detail/${accountId}/${emailId}?${qs.stringify(
          payload
        )}`
      );
    return res.data;
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};

export const postEmail = async ({
  payload,
  accountId,
}: {
  payload: EmailUpsertPayload;
  accountId: string;
}): Promise<void> => {
  try {
    await AxiosInstance.post(`${API_PATH}/create/${accountId}`, payload);
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};

export const putEmail = async ({
  payload,
  accountId,
  emailId,
}: {
  payload: EmailUpsertPayload;
  accountId: string;
  emailId: string;
}): Promise<void> => {
  try {
    await AxiosInstance.put(
      `${API_PATH}/update/${accountId}/${emailId}`,
      payload
    );
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};
export const deleteEmail = async ({
  accountId,
  emailId,
}: {
  accountId: string;
  emailId: string;
}): Promise<void> => {
  try {
    await AxiosInstance.delete(`${API_PATH}/delete/${accountId}/${emailId}`);
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};
